import { createGraphQLRequest } from "../../../api/utils/httpRequest"
import { sendEvent } from "../../../events/utils"
import type {
    EventSendRequestData,
    FeatureFlagSendRequestData,
    MutationOndyPlatformArgs,
    OperationsSendRequestData,
} from "../../../graphql/types"

export const operationsSendRequest = (headers: Record<string, any>, data: OperationsSendRequestData): Promise<any> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation operationsSend($data: OperationsSendRequestData!) {
                    operationsSend(data: $data) {
                      success
                    }
                }
            `,
            operationName: "operationsSend",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.operationsSend) {
            return response.data.operationsSend
        }

        return []
    })

/** @deprecated */
export const eventSendRequest = (headers: Record<string, any>, data: EventSendRequestData): Promise<any> =>
    sendEvent(headers, data)

export const featureFlagSendRequest = (headers: Record<string, any>, data: FeatureFlagSendRequestData): Promise<any> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation featureFlagSend($data: FeatureFlagSendRequestData!) {
                    featureFlagSend(data: $data) {
                      success
                    }
                }
            `,
            operationName: "featureFlagSend",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.featureFlagSend) {
            return response.data.featureFlagSend
        }

        return []
    })

export const getOndyPlatformRequest = async (headers: Record<string, any>): Promise<string> => {
    const response = await createGraphQLRequest({
        headers: headers,
        body: {
            query: "query ondyPlatform { ondyPlatform }",
            operationName: "ondyPlatform",
        },
    }).catch(() => null)
    return response?.data?.ondyPlatform ?? "onfleet"
}

export const setOndyPlatformRequest = async (
    headers: Record<string, any>,
    data: MutationOndyPlatformArgs
): Promise<string> => {
    const response = await createGraphQLRequest({
        headers: headers,
        body: {
            query: "mutation ondyPlatform($platform: String!) { ondyPlatform(platform: $platform) }",
            operationName: "ondyPlatform",
            variables: data,
        },
    })
    return response?.data
}
